//
// IMPORTS
//

// Base URL for the API
import { apiUrl } from '@/constants'

import { testFbId } from './index'

import { httpRequest } from '@/services/api'

//
//
//
// ENDPOINTS PARA O GESTOR DE PLANOS
//
//
//

// Atualiza o plano personalizado de um usuário
const apiUpdateUserCustomPlan = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/userplan/save`, payload, token })

// Desfaz o plano personalizado de um usuário
const apiUndoUserCustomPlan = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/userplan/undo`, payload, token })

// Ler capacidades de um usuário
const apiGetUserCapabilities = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/userplan`, payload, token })

//
//
//
// ENDPOINTS PARA A JANELA DE PAGAMENTO
//
//
//

// Pagamento na VINDI
const apiMakePayment = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/paynew`, payload, token })

// Ler dados pessoais de pagamento (SE HOUVER)
const apiGetUserPaymentProfile = token => httpRequest({ method: 'GET', url: `${apiUrl}/managers/me`, token })

//
//
//
// ENDPOINTS PARA A TELA DE ASSINATURA
//
//
//

// Ativar cupom
const apiActivateCoupon = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/coupon`, payload, token })

// Cancelar plano na VINDI
const apiCancelSubscription = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/payments/cancel`, payload, token })

//
//
//
// ENDPOINTS DE SESSÃO
//
//
//

// Ler capacidades do usuário logado/autenticado
const apiFetchAuthenticatedUserCapabilities = (payload, token) => httpRequest({ method: 'POST', url: `${apiUrl}/managers/auth`, payload, token })

//
//
//
// GET ADDRESS BY CEP
//
//
//

const apiGetAddressByCep = cep => httpRequest({ method: 'GET', url: `https://viacep.com.br/ws/${cep}/json` })

//
//
//
// Relaciona um usuário com escalas específicas
//
//
//

const apiSetUserScales = (groupID, scaleID, users = []) => {
  const updates = {
    [`escalas/${groupID}/${scaleID}/relatedUsers`]: users.length > 0 ? Object.fromEntries(users.map(userID => [userID, true])) : null,
  }

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        resolve({
          code: error ? 0 : 1,
          message: error ? 'Não foi possível atualizar as escalas do usuário' : 'As escalas do usuário foram atualizadas',
          debug: updates,
          error,
        })
      })
    } catch (error) {
      resolve({
        code: 0,
        message: 'Não foi possível atualizar as escalas do usuário',
        debug: updates,
        error,
      })
    }
  })
}

//
//
//
// Vincula o usuário ao grupo
//
//
//

const apiAddUserToGroup = (userID = false, groupID = false, cCallback = () => {}) => {
  const updates = {
    [`grupos/${groupID}/users/${userID}`]: { admin: false, enablePush: true }, // Vincula o usuário no grupo
    [`users/${userID}/grupos/${groupID}`]: { admin: false, enablePush: true }, // Vincula o grupo no usuário
  }

  // ATUALIZA DADOS NO BANCO
  try {
    testFbId.ref().update(updates,
    error => {
      if (error) {
        cCallback({
          code: 0,
          message: 'Não foi possível adicionar o usuário no grupo',
          error,
        })
      } else {
        cCallback({
          code: 1,
          message: 'O usuário foi adicionado no grupo',
          debug: updates,
          error: '',
        })
      }
    })
  } catch (error) {
    cCallback({
      code: 0,
      message: 'Não foi possível adicionar o usuário no grupo',
      error,
    })
  }
}

//
//
//
// ?
//
//
//

const apiCreateUser = payload => httpRequest({ method: 'POST', url: `${apiUrl}/new_user`, payload })

//
//
//
// Atribui municípios a um usuário
//
//
//

const apiSetUserMunicipalities = (userID = false, groupID = false, users = []) => {
  const payload = Object.fromEntries(users.map(userID => [userID, true]))

  const updates = {}
  updates['grupos/' + groupID + '/users/' + userID + '/municipalities'] = users.length > 0 ? payload : null
  // updates['/users/' + userID + '/grupos/' + groupID + '/municipalities'] = users.length > 0 ? payload : null

  //
  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        resolve({
          code: error ? 0 : 1,
          message: error ? 'Não foi possível atualizar os municípios do usuário no grupo' : 'Os municípios do usuário foram atualizados no grupo',
          debug: updates,
          error,
        })
      })
    } catch (error) {
      resolve({
        code: 0,
        message: 'Não foi possível atualizar os municípios do usuário no grupo',
        debug: updates,
        error,
      })
    }
  })
}

//
//
//
// SAÍDA
//
//
//

export {
  apiUpdateUserCustomPlan,
  apiUndoUserCustomPlan,
  apiGetUserCapabilities,

  apiMakePayment,
  apiGetUserPaymentProfile,

  apiActivateCoupon,
  apiCancelSubscription,

  apiFetchAuthenticatedUserCapabilities,

  apiGetAddressByCep,

  apiSetUserScales,
  apiAddUserToGroup,
  apiCreateUser,

  apiSetUserMunicipalities,
}
